import React from 'react';
import './header.css';

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';

import person from '../../assets/Header-Banner-Pantja-Laundry-KamranAydinov.png';

const Header = () => {
  return (
    <div className="pl__header section__padding" id="home">
      <div className="pl__header-image">
        <AnimationOnScroll animateIn="animate__fadeInUp">
          <img src={person} alt="Laundry Terdekat di Pantja Laundry" />
        </AnimationOnScroll>
      </div>
      <div className="pl__header-content">
        <h1 className="gradient__text">Cuci Bersih dan Hemat <br id='brHide' />di Pantja Laundry</h1>
        <p>Sudah sibuk tiap hari kerja, belum sempat cuci pakaian?<br />Jangan biarkan keranjang pakaian Anda menumpuk lama, serahkan ke Pantja Laundry aja!</p>
      </div>
    </div>
  )
}

export default Header